// standard flat ui color palette courtesy of Designmodo

const colorflatui = {
    turquoise: {
        1: ['#1abc9c']
    },
    green_sea: {
        1: ['#16a085']
    },
    emerald: {
        1: ['#2ecc71']
    },
    nephritis: {
        1: ['#27ae60']
    },
    peter_river: {
        1: ['#3498db']
    },
    belize_hole: {
        1: ['#2980b9']
    },
    amethyst: {
        1: ['#9b59b6']
    },
    wisteria: {
        1: ['#8e44ad']
    },
    wet_asphalt: {
        1: ['#34495e']
    },
    midnight_blue: {
        1: ['#2c3e50']
    },
    sun_flower: {
        1: ['#f1c40f']
    },
    orange: {
        1: ['#f39c12']
    },
    carrot: {
        1: ['#e67e22']
    },
    pumpkin: {
        1: ['#d35400']
    },
    alizarin: {
        1: ['#e74c3c']
    },
    pomergranate: {
        1: ['#c0392b']
    },
    clouds: {
        1: ['#ecf0f1']
    },
    silver: {
        1: ['#bdc3c7']
    },
    concrete: {
        1: ['#95a5a6']
    },
    asbestos: {
        1: ['#7f8c8d']
    },
    reef: {
        1: ['#00cec9']
    },
    mint_leaf: {
        1: ['#00b894']
    },
    lime: {
        1: ['#a3cb38']
    },
    forest: {
        1: ['#218c74']
    },
    lagoon: {
        1: ['#1e90ff']
    },
    deep_ocean: {
        1: ['#0a3d62']
    },
    lavender: {
        1: ['#c8a2c8']
    },
    plum: {
        1: ['#6a0dad']
    },
    charcoal: {
        1: ['#2f3640']
    },
    night: {
        1: ['#1e272e']
    },
    banana: {
        1: ['#f6e58d']
    },
    honey: {
        1: ['#e1b12c']
    },
    amber: {
        1: ['#ffbf00']
    },
    bronze: {
        1: ['#cd7f32']
    },
    coral: {
        1: ['#ff6b6b']
    },
    wine: {
        1: ['#8e1b1b']
    },
    sand: {
        1: ['#f4d03f']
    },
    smoke: {
        1: ['#dcdde1']
    },
    stone: {
        1: ['#8395a7']
    },
    slate: {
        1: ['#576574']
    }
};

export default colorflatui;



// WEBPACK FOOTER //
// ./src/scripts/core/tools/colorflatui.js